export default "__VITE_ASSET__2kG0BsZF__"